import React, {useContext} from "react"
import Box from "@amzn/meridian/box";
import Row from "@amzn/meridian/row";
import MetricViewV2 from "./MetricViewV2";
import {AssociateFilterContextV2} from "./context/AssociateFilterContextV2";
import {AssociatePerformanceContextV2} from "./context/AssociatePerformanceContextV2";
import {NO, YES} from "../util/Constants";

const AssociatePerformanceMetricsV2 = () => {
    const {states} = useContext(AssociateFilterContextV2)
    const {viewModel} = useContext(AssociatePerformanceContextV2);

    const filteredAssociates = viewModel.associatePerformance
        .filter(associate => states.length === 0 || states.includes(associate.active));
    const activeAssociateCount = filteredAssociates.filter(associate => associate.active === YES).length;
    const inActiveAssociateCount = filteredAssociates.filter(associate => associate.active === NO).length;

    return (
        <Row spacingInset="none none medium none">
            <Box type="outline" spacingInset="medium">
                <MetricViewV2 data={{
                    headerId: "associate.totalAssociates",
                    defaultHeader: "Total associates",
                    metricValue: filteredAssociates.length
                }}/>
            </Box>

            <Box type="outline" spacingInset="medium">
                <Row>
                    <MetricViewV2 data={{
                        headerId: "associate.associatesWithStageTask",
                        defaultHeader: "Associates with stage tasks assigned",
                        metricValue: activeAssociateCount
                    }}/>
                    <MetricViewV2 data={{
                        headerId: "associate.associatesWithoutStageTask",
                        defaultHeader: "Associates with no stage task assigned",
                        metricValue: inActiveAssociateCount
                    }}/>
                </Row>
            </Box>
        </Row>
    )
}

export default AssociatePerformanceMetricsV2


// WEBPACK FOOTER //
// ./src/components/outboundassociate/AssociatePerformanceMetricsV2.js